export default {
  D: "PAID",
  C: "RECIEVED",
  d: "RECIEVED",
  c: "PAID",
};